module.exports = __webpack_public_path__ + "static/media/TACLAI_MENU-normal.62905e88.png";